// import React, { useState, useEffect } from 'react'
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Grid,
//   TextField,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   IconButton,
// } from '@mui/material'
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
// import { DatePicker } from '@mui/x-date-pickers/DatePicker'
// import { TimePicker } from '@mui/x-date-pickers/TimePicker'
// import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
// import ClearIcon from '@mui/icons-material/Clear'
// import DeleteIcon from '@mui/icons-material/Delete'
// import AddIcon from '@mui/icons-material/Add'
// import dayjs from 'dayjs'

// const EditDeemedLogDialog = ({ 
//   open, 
//   onClose, 
//   logData, 
//   onSave, 
//   plantData,
//   isAuthorised 
// }) => {
//   const [EnergyLoss, setEnergyLoss] = useState(0)
//   const [faultType, setfaultType] = useState('')
//   const [faultDescription, setfaultDescription] = useState('')
//   const [DeemedDate, setDeemedDate] = useState(dayjs(new Date()))
//   const [accountability, setAccountability] = useState('DE')
//   const [multiplyingFactor, setMultiplyingFactor] = useState('')
//   const [timePeriods, setTimePeriods] = useState([{ from: null, to: null }])

//   const [errors, setErrors] = useState({
//     EnergyLoss: '',
//     faultType: '',
//     DeemedDate: '',
//     faultDescription: '',
//     accountability: '',
//     multiplyingFactor: '',
//   })

//   const MenuData = [
//     'Grid Failure',
//     'Inverter Failure',
//     'Manually inverter/breaker turned off',
//     'Any Equipment Failure',
//     'Any Other Fault',
//   ]

//   // Parse duration string to time periods
//   const parseDurationToTimePeriods = (durationString) => {
//     if (!durationString) return [{ from: null, to: null }]

//     const periods = durationString.includes(' | ') 
//       ? durationString.split(' | ') 
//       : [durationString]

//     return periods.map(period => {
//       const [startTime, endTime] = period.split(' : ')
//       return {
//         from: startTime ? dayjs(`2000-01-01 ${startTime}`) : null,
//         to: endTime ? dayjs(`2000-01-01 ${endTime}`) : null
//       }
//     })
//   }

//   // Initialize form with existing log data
//   useEffect(() => {
//     if (logData && open) {
//       setEnergyLoss(logData.energyLoss || 0)
//       setfaultType(logData.faultType || '')
//       setfaultDescription(logData.description || '')
//       setDeemedDate(dayjs(logData.logDate))
//       setAccountability(logData.accountability || 'DE')
//       setMultiplyingFactor(logData.multiplyingFactor || '')
      
//       // Parse duration into time periods
//       const periods = parseDurationToTimePeriods(logData.duration)
//       setTimePeriods(periods)
//     }
//   }, [logData, open])

//   const validateForm = () => {
//     let isValid = true
//     const newErrors = { ...errors }

//     if (!EnergyLoss) {
//       newErrors.EnergyLoss = 'Energy Loss is required'
//       isValid = false
//     } else {
//       newErrors.EnergyLoss = ''
//     }

//     if (!faultType) {
//       newErrors.faultType = 'Fault Type is required'
//       isValid = false
//     } else {
//       newErrors.faultType = ''
//     }

//     if (!DeemedDate) {
//       newErrors.DeemedDate = 'Choose Date is required'
//       isValid = false
//     } else {
//       newErrors.DeemedDate = ''
//     }

//     if (!faultDescription) {
//       newErrors.faultDescription = 'Fault Description is required'
//       isValid = false
//     } else {
//       newErrors.faultDescription = ''
//     }

//     setErrors(newErrors)
//     return isValid
//   }

//   const addTimePeriod = () => {
//     setTimePeriods([...timePeriods, { from: null, to: null }])
//   }

//   const removeTimePeriod = (index) => {
//     if (timePeriods.length > 1) {
//       const newPeriods = [...timePeriods]
//       newPeriods.splice(index, 1)
//       setTimePeriods(newPeriods)
//     }
//   }

//   const updateTimePeriod = (index, field, value) => {
//     const newPeriods = [...timePeriods]
//     newPeriods[index][field] = value
//     setTimePeriods(newPeriods)
//   }

//   const handleSave = () => {
//     if (validateForm()) {
//       const months = [
//         'January', 'February', 'March', 'April', 'May', 'June',
//         'July', 'August', 'September', 'October', 'November', 'December',
//       ]
      
//       const today = new Date(DeemedDate)
//       const CurrentMonth = today.getMonth()

//       const durationString = timePeriods
//         .map(period => {
//           if (!period.from || !period.to) return null
//           return `${period.from.format('HH:mm')} : ${period.to.format('HH:mm')}`
//         })
//         .filter(Boolean)
//         .join(' | ')

//       const updatedData = {
//         logId: logData.logId,
//         plantId: logData.plantId,
//         logDate: DeemedDate,
//         duration: durationString,
//         energyLoss: EnergyLoss,
//         description: faultDescription,
//         faultType: faultType,
//         logMonth: months[CurrentMonth],
//         accountability: accountability,
//         multiplyingFactor: multiplyingFactor,
//       }

//       onSave(updatedData)
//     }
//   }

//   const handleClose = () => {
//     // Reset form
//     setEnergyLoss(0)
//     setfaultType('')
//     setfaultDescription('')
//     setDeemedDate(dayjs(new Date()))
//     setAccountability('DE')
//     setMultiplyingFactor('')
//     setTimePeriods([{ from: null, to: null }])
//     setErrors({
//       EnergyLoss: '',
//       faultType: '',
//       DeemedDate: '',
//       faultDescription: '',
//       accountability: '',
//       multiplyingFactor: '',
//     })
//     onClose()
//   }

//   return (
//     <Dialog
//       className="businessview_dialog"
//       open={open}
//       onClose={handleClose}
//       maxWidth="md"
//       fullWidth
//     >
//       <DialogTitle>
//         <div className="align_btw brdr">
//           <div className="h_1">Edit Deemed Generation Log Entry</div>
//           <DialogActions>
//             <ClearIcon onClick={handleClose} className="pointer" />
//           </DialogActions>
//         </div>
//       </DialogTitle>
//       <DialogContent>
//         <Grid container spacing={2}>
//           <Grid item xs={12} md={12}>
//             <div className="capacity" style={{ textAlign: 'right' }}>
//               Capacity {plantData?.plantSize}KW
//             </div>
//           </Grid>
          
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Energy Loss"
//               value={EnergyLoss}
//               onChange={(e) => setEnergyLoss(Number(e.target.value))}
//               error={Boolean(errors.EnergyLoss)}
//               helperText={errors.EnergyLoss}
//               variant="outlined"
//               fullWidth
//               type="number"
//             />
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <FormControl sx={{ width: '100%' }}>
//               <InputLabel id="fault-type-label" className="form_label">
//                 Fault Type
//               </InputLabel>
//               <Select
//                 labelId="fault-type-label"
//                 id="fault-type-select"
//                 value={faultType}
//                 label="Fault Type"
//                 onChange={(e) => setfaultType(e.target.value)}
//                 error={Boolean(errors.faultType)}
//                 sx={{
//                   borderRadius: '5px',
//                   backgroundColor: '#fff',
//                   boxShadow: '4px 4px 15px rgba(0, 0, 0, 0.05)',
//                 }}
//               >
//                 {MenuData.map((data, index) => (
//                   <MenuItem key={index} value={data}>{data}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Multiplying Factor"
//               type="number"
//               value={multiplyingFactor}
//               onChange={(e) => setMultiplyingFactor(Number(e.target.value))}
//               disabled={!isAuthorised}
//               variant="outlined"
//               fullWidth
//               helperText={!isAuthorised ? 'Only authorized users can edit this' : ''}
//             />
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <LocalizationProvider dateAdapter={AdapterDayjs}>
//               <DemoContainer components={['DatePicker']}>
//                 <DatePicker
//                   label="Choose Date"
//                   maxDate={dayjs()}
//                   format="DD-MM-YYYY"
//                   value={DeemedDate}
//                   onChange={(value) => setDeemedDate(value)}
//                   error={Boolean(errors.DeemedDate)}
//                 />
//               </DemoContainer>
//             </LocalizationProvider>
//           </Grid>

//           <Grid item xs={12} md={12}>
//             {timePeriods.map((period, index) => (
//               <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
//                 <div style={{ display: 'flex', flex: 1 }}>
//                   <LocalizationProvider dateAdapter={AdapterDayjs}>
//                     <DemoContainer components={['TimePicker']}>
//                       <TimePicker
//                         label="Start Time"
//                         value={period.from}
//                         onChange={(value) => updateTimePeriod(index, 'from', value)}
//                         sx={{ marginRight: '10px' }}
//                       />
//                     </DemoContainer>
//                   </LocalizationProvider>
//                   <LocalizationProvider dateAdapter={AdapterDayjs}>
//                     <DemoContainer components={['TimePicker']}>
//                       <TimePicker
//                         label="End Time"
//                         value={period.to}
//                         onChange={(value) => updateTimePeriod(index, 'to', value)}
//                         sx={{ marginRight: '10px' }}
//                       />
//                     </DemoContainer>
//                   </LocalizationProvider>
//                 </div>
//                 {timePeriods.length > 1 && (
//                   <IconButton onClick={() => removeTimePeriod(index)}>
//                     <DeleteIcon />
//                   </IconButton>
//                 )}
//                 {index === timePeriods.length - 1 && (
//                   <IconButton onClick={addTimePeriod}>
//                     <AddIcon />
//                   </IconButton>
//                 )}
//               </div>
//             ))}
//           </Grid>

//           <Grid item xs={12} md={12}>
//             <TextField
//               label="Fault Description"
//               multiline
//               rows={4}
//               value={faultDescription}
//               onChange={(e) => setfaultDescription(e.target.value)}
//               error={Boolean(errors.faultDescription)}
//               helperText={errors.faultDescription}
//               variant="outlined"
//               fullWidth
//             />
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <FormControl sx={{ width: '100%' }}>
//               <InputLabel id="accountability-label" className="form_label">
//                 Accountability
//               </InputLabel>
//               <Select
//                 labelId="accountability-label"
//                 id="accountability-select"
//                 value={accountability}
//                 label="Accountability"
//                 onChange={(e) => setAccountability(e.target.value)}
//               >
//                 <MenuItem value="DE">DE</MenuItem>
//                 <MenuItem value="Customer">Customer</MenuItem>
//               </Select>
//             </FormControl>
//           </Grid>
//         </Grid>

//         <DialogActions>
//           <button className="save_btn" onClick={handleSave}>
//             Update
//           </button>
//         </DialogActions>
//       </DialogContent>
//     </Dialog>
//   )
// }

// export default EditDeemedLogDialog

import React, { useState, useEffect } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
} from '@mui/material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import ClearIcon from '@mui/icons-material/Clear'
import DeleteIcon from '@mui/icons-material/Delete'
import AddIcon from '@mui/icons-material/Add'
import dayjs from 'dayjs'

const EditDeemedLogDialog = ({ 
  open, 
  onClose, 
  logData, 
  onSave, 
  plantData,
  isAuthorised 
}) => {
  const [EnergyLoss, setEnergyLoss] = useState(0)
  const [faultType, setfaultType] = useState('')
  const [faultDescription, setfaultDescription] = useState('')
  const [DeemedDate, setDeemedDate] = useState(dayjs(new Date()))
  const [accountability, setAccountability] = useState('DE')
  const [multiplyingFactor, setMultiplyingFactor] = useState('')
  const [timePeriods, setTimePeriods] = useState([{ from: null, to: null }])

  const [errors, setErrors] = useState({
    EnergyLoss: '',
    faultType: '',
    DeemedDate: '',
    faultDescription: '',
    accountability: '',
    multiplyingFactor: '',
  })

  const MenuData = [
    'Grid Failure',
    'Inverter Failure',
    'Manually inverter/breaker turned off',
    'Any Equipment Failure',
    'Any Other Fault',
  ]

  // Calculate total duration in minutes
  const calculateTotalDuration = (periods) => {
    return periods.reduce((total, period) => {
      if (period.from && period.to) {
        const startTime = dayjs(period.from)
        const endTime = dayjs(period.to)
        const durationInMinutes = endTime.diff(startTime, 'minute')
        return total + durationInMinutes
      }
      return total
    }, 0)
  }

  // Auto-calculate Energy Loss when time periods or multiplying factor change
  useEffect(() => {
    const totalDurationMinutes = calculateTotalDuration(timePeriods)
    const calculatedEnergyLoss = totalDurationMinutes * (multiplyingFactor || 0)
    setEnergyLoss(calculatedEnergyLoss)
  }, [timePeriods, multiplyingFactor])

  // Parse duration string to time periods
  const parseDurationToTimePeriods = (durationString) => {
    if (!durationString) return [{ from: null, to: null }]

    const periods = durationString.includes(' | ') 
      ? durationString.split(' | ') 
      : [durationString]

    return periods.map(period => {
      const [startTime, endTime] = period.split(' : ')
      return {
        from: startTime ? dayjs(`2000-01-01 ${startTime}`) : null,
        to: endTime ? dayjs(`2000-01-01 ${endTime}`) : null
      }
    })
  }

  // Initialize form with existing log data
  useEffect(() => {
    if (logData && open) {
      setfaultType(logData.faultType || '')
      setfaultDescription(logData.description || '')
      setDeemedDate(dayjs(logData.logDate))
      setAccountability(logData.accountability || 'DE')
      setMultiplyingFactor(logData.multiplyingFactor || '')
      
      // Parse duration into time periods
      const periods = parseDurationToTimePeriods(logData.duration)
      setTimePeriods(periods)
      
      // Note: EnergyLoss will be auto-calculated by the useEffect above
    }
  }, [logData, open])

  const validateForm = () => {
    let isValid = true
    const newErrors = { ...errors }

    if (!EnergyLoss) {
      newErrors.EnergyLoss = 'Energy Loss is required'
      isValid = false
    } else {
      newErrors.EnergyLoss = ''
    }

    if (!faultType) {
      newErrors.faultType = 'Fault Type is required'
      isValid = false
    } else {
      newErrors.faultType = ''
    }

    if (!DeemedDate) {
      newErrors.DeemedDate = 'Choose Date is required'
      isValid = false
    } else {
      newErrors.DeemedDate = ''
    }

    if (!faultDescription) {
      newErrors.faultDescription = 'Fault Description is required'
      isValid = false
    } else {
      newErrors.faultDescription = ''
    }

    setErrors(newErrors)
    return isValid
  }

  const addTimePeriod = () => {
    setTimePeriods([...timePeriods, { from: null, to: null }])
  }

  const removeTimePeriod = (index) => {
    if (timePeriods.length > 1) {
      const newPeriods = [...timePeriods]
      newPeriods.splice(index, 1)
      setTimePeriods(newPeriods)
    }
  }

  const updateTimePeriod = (index, field, value) => {
    const newPeriods = [...timePeriods]
    newPeriods[index][field] = value
    setTimePeriods(newPeriods)
  }

  const handleSave = () => {
    if (validateForm()) {
      const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December',
      ]
      
      const today = new Date(DeemedDate)
      const CurrentMonth = today.getMonth()

      const durationString = timePeriods
        .map(period => {
          if (!period.from || !period.to) return null
          return `${period.from.format('HH:mm')} : ${period.to.format('HH:mm')}`
        })
        .filter(Boolean)
        .join(' | ')

      const updatedData = {
        logId: logData.logId,
        plantId: logData.plantId,
        logDate: DeemedDate,
        duration: durationString,
        energyLoss: EnergyLoss,
        description: faultDescription,
        faultType: faultType,
        logMonth: months[CurrentMonth],
        accountability: accountability,
        multiplyingFactor: multiplyingFactor,
      }

      onSave(updatedData)
    }
  }

  const handleClose = () => {
    // Reset form
    setEnergyLoss(0)
    setfaultType('')
    setfaultDescription('')
    setDeemedDate(dayjs(new Date()))
    setAccountability('DE')
    setMultiplyingFactor('')
    setTimePeriods([{ from: null, to: null }])
    setErrors({
      EnergyLoss: '',
      faultType: '',
      DeemedDate: '',
      faultDescription: '',
      accountability: '',
      multiplyingFactor: '',
    })
    onClose()
  }

  return (
    <Dialog
      className="businessview_dialog"
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        <div className="align_btw brdr">
          <div className="h_1">Edit Deemed Generation Log Entry</div>
          <DialogActions>
            <ClearIcon onClick={handleClose} className="pointer" />
          </DialogActions>
        </div>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <div className="capacity" style={{ textAlign: 'right' }}>
              Capacity {plantData?.plantSize}KW
            </div>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <TextField
              label="Energy Loss (Auto Calculated)"
              value={EnergyLoss}
              disabled
              variant="outlined"
              fullWidth
              type="text"
              helperText={`Total Duration: ${calculateTotalDuration(
                timePeriods
              )} minutes × Multiplying Factor: ${
                multiplyingFactor || 0
              } = ${EnergyLoss}`}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl sx={{ width: '100%' }}>
              <InputLabel id="fault-type-label" className="form_label">
                Fault Type
              </InputLabel>
              <Select
                labelId="fault-type-label"
                id="fault-type-select"
                value={faultType}
                label="Fault Type"
                onChange={(e) => setfaultType(e.target.value)}
                error={Boolean(errors.faultType)}
                sx={{
                  borderRadius: '5px',
                  backgroundColor: '#fff',
                  boxShadow: '4px 4px 15px rgba(0, 0, 0, 0.05)',
                }}
              >
                {MenuData.map((data, index) => (
                  <MenuItem key={index} value={data}>{data}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Multiplying Factor"
              type="number"
              value={multiplyingFactor}
              onChange={(e) => setMultiplyingFactor(Number(e.target.value))}
              disabled={!isAuthorised}
              variant="outlined"
              fullWidth
              helperText={!isAuthorised ? 'Only authorized users can edit this' : ''}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker']}>
                <DatePicker
                  label="Choose Date"
                  maxDate={dayjs()}
                  format="DD-MM-YYYY"
                  value={DeemedDate}
                  onChange={(value) => setDeemedDate(value)}
                  error={Boolean(errors.DeemedDate)}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12} md={12}>
            {timePeriods.map((period, index) => (
              <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                <div style={{ display: 'flex', flex: 1 }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['TimePicker']}>
                      <TimePicker
                        label="Start Time"
                        value={period.from}
                        onChange={(value) => updateTimePeriod(index, 'from', value)}
                        sx={{ marginRight: '10px' }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['TimePicker']}>
                      <TimePicker
                        label="End Time"
                        value={period.to}
                        onChange={(value) => updateTimePeriod(index, 'to', value)}
                        sx={{ marginRight: '10px' }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
                {timePeriods.length > 1 && (
                  <IconButton onClick={() => removeTimePeriod(index)}>
                    <DeleteIcon />
                  </IconButton>
                )}
                {index === timePeriods.length - 1 && (
                  <IconButton onClick={addTimePeriod}>
                    <AddIcon />
                  </IconButton>
                )}
              </div>
            ))}
          </Grid>

          <Grid item xs={12} md={12}>
            <TextField
              label="Fault Description"
              multiline
              rows={4}
              value={faultDescription}
              onChange={(e) => setfaultDescription(e.target.value)}
              error={Boolean(errors.faultDescription)}
              helperText={errors.faultDescription}
              variant="outlined"
              fullWidth
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl sx={{ width: '100%' }}>
              <InputLabel id="accountability-label" className="form_label">
                Accountability
              </InputLabel>
              <Select
                labelId="accountability-label"
                id="accountability-select"
                value={accountability}
                label="Accountability"
                onChange={(e) => setAccountability(e.target.value)}
              >
                <MenuItem value="DE">DE</MenuItem>
                <MenuItem value="Customer">Customer</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <DialogActions>
          <button className="save_btn" onClick={handleSave}>
            Update
          </button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}

export default EditDeemedLogDialog